import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=4b30371a"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=4b30371a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../Web.HP/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports